import service from '@/utils/server';

const modName='/md/plantStorage/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};

/**
 * 图片上传
 */
export const uploadUrl = process.env.BASE_URL + '/md/plantStorage/queuesImgUpload';

export const getImagePreviewURL = (fileCode) => {
  return `${process.env.BASE_URL}/common/web/image/preview/${fileCode}`;
};
//新增提交
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//编辑库位查询
export const storageDetails = data => {
  return service({
    url: modName + 'storageDetails',
    method: 'post',
    data
  });
};

//库位编辑提交
export const editData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};

//设置毒素查询
export const settingToxinDetails = data => {
  return service({
    url: modName + 'settingToxinDetails',
    method: 'post',
    data
  });
};
//毒素设置提交
export const settingToxin = data => {
  return service({
    url: modName + 'settingToxin',
    method: 'post',
    data
  });
};

//设置批次查询
export const settingBatchDetails = data => {
  return service({
    url: modName + 'settingBatchDetails',
    method: 'post',
    data
  });
};

//批次设置提交
export const settingBatchNo = data => {
  return service({
    url: modName + 'settingBatchNo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/plantStorage/api/index.js